import { render, staticRenderFns } from "./ReactivateSubscription.vue?vue&type=template&id=0072b1c2&scoped=true&"
import script from "./ReactivateSubscription.vue?vue&type=script&lang=js&"
export * from "./ReactivateSubscription.vue?vue&type=script&lang=js&"
import style0 from "./ReactivateSubscription.vue?vue&type=style&index=0&id=0072b1c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0072b1c2",
  null
  
)

export default component.exports